import { UserProfileResult } from '@/models/dto'
import { AdminSetPasswordPayload, ResetPasswordPayload, SetPasswordPayload, ValidatePasswordRequest, ValidatePasswordResponse } from '@/models/dto/Password'
import { HttpService } from '@/services/common/HttpService'
import { AxiosResponse } from 'axios'

const httpService: HttpService = new HttpService()

export default {
  getUserProfileWithToken(): Promise<AxiosResponse<UserProfileResult>> {
    const url = `/auth/jwt`
    return httpService.post(url, {})
  },

  /**
   * Retrieves the current user's roles and permissions.
   *
   * @returns A promise that resolves to the user's roles and permissions.
   */
  getUserRolesAndPermissions(): Promise<AxiosResponse<UserProfileResult>> {
    const url = `/userProfile`
    return httpService.get(url)
  },

  /**
   * Validates password against our password policy
   *
   * @param password - new password chosen by the user
   * @returns A promise with the result of validation
   */
  validatePassword(password: string): Promise<AxiosResponse<ValidatePasswordResponse>> {
    const url = `/v2/password/validate`
    return httpService.post<ValidatePasswordResponse, ValidatePasswordRequest>(url, { password })
  },

  /**
   * Sets a new password for the user
   *
   * @param payload - the payload containing the user id, old password, and new password
   * @returns A promise with the result of setting the password
   */
  setPassword(payload: SetPasswordPayload): Promise<AxiosResponse<void>> {
    const url = `/v2/password/set`
    return httpService.post(url, payload)
  },

  /**
   * Sets a new password for the user
   *
   * @param payload - the payload containing the user id and new password
   * @returns A promise with the result of setting the password
   */
  adminSetPassword(payload: AdminSetPasswordPayload): Promise<AxiosResponse<void>> {
    const url = `/v2/password/set/admin`
    return httpService.post(url, payload)
  },
}
